import { createFileRoute, redirect } from '@tanstack/react-router'
import { DistributionModesPage } from '@/pages/Distribution/DistributionModesPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/distribution-modes')({
  component: DistributionModesPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/distribution-modes')) {
      throw redirect({ to: '/' })
    }
  },
})
